module.exports = __webpack_public_path__ + "3e6132de94190ea60ae547582962b6ec.png";